const MAX_PAGES = 20;
const PAGE_SIZE = 48;
const DEFAULT_PAGE = 1;
const TOTAL_RESULTS_TRANSLATE_BUTTON_SEPARATOR = '-';
const PAGE_NAME = 'tag_page';
const MIXPANEL_PAGE_NAME = 'Tag page';
const READINESS_MANAGER_GLOBALS_INIT = 'tag_page_perseus_globals_init';
const HOUR_IN_SEC = 3600;

const STATUS_CODE = {
    BAD_REQUEST: 400,
    NOT_FOUND: 404,
    GONE: 410,
    INTERNAL_SERVER_ERROR: 500,
};

export {
    MAX_PAGES,
    PAGE_SIZE,
    DEFAULT_PAGE,
    TOTAL_RESULTS_TRANSLATE_BUTTON_SEPARATOR,
    PAGE_NAME,
    MIXPANEL_PAGE_NAME,
    READINESS_MANAGER_GLOBALS_INIT,
    HOUR_IN_SEC,
    STATUS_CODE,
};
